<template>
  <div class="page-content">
    <div class="content">
      <table-content :columns='columns' :tableData="tableData" @handleEdit='handleEdit' @handleDelete='handleDelete' optionWidth='160'>
        <template #from>
          <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
            <el-form-item>
              <el-select v-model="filters.companyId" placeholder="请选择" filterable clearable >
                <el-option label="全部客户" :value="0" ></el-option>
                <el-option v-for="item in allCompany" :key="item.value" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 300px;" v-model="filters.contactId" placeholder="请选择" collapse-tags multiple filterable clearable >
                <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template #option='scope'>
          <el-button @click.native.prevent="handleClientContactInfo(scope.scope)" type="text" :size="size" >联系人</el-button>
          <el-button @click.native.prevent="handleProjectConfig(scope.scope)" type="text" :size="size" >项目配置</el-button>
        </template>
      </table-content>
    </div>
    <add-or-update ref="addOrUpdate" v-if="addOrUpdateVisible" :contactList='contactList' @handleQuery='handleQuery'></add-or-update>
    <!-- 项目配置 -->
    <project-config ref="projectConfig" v-if="projectConfigVisible" @handleQuery='handleQuery' ></project-config>
    <!-- 联系人 -->
    <client-contact-info ref="clientContactInfo" v-if="clientContactInfoVisible"></client-contact-info>
  </div>
</template>

<script>
import addOrUpdate from './addOrUpdate.vue'
import tableContent from './tableContent.vue'
import projectConfig from './projectConfig.vue'
import clientContactInfo from './clientContactInfo.vue'
export default {
  components: {
    tableContent,
    addOrUpdate,
    projectConfig,
    clientContactInfo
  },
  data () {
    return {
      clientContactInfoVisible: false,
      projectConfigVisible: false,
      addOrUpdateVisible: false,
      size: 'small',
      contactList: [],
      allCompany: [],
      filters: {
        companyId: 0,
        contactId: []
      },
      columns: [
        { prop: 'projectName', label: '项目名称', minWidth: 200 },
        { prop: 'projectNumber', label: '项目编号', minWidth: 160 },
        { prop: 'contractName', label: '关联合同', minWidth: 200 },
        { prop: 'contractNumber', label: '关联合同编号', minWidth: 160 },
        { prop: 'projectRemark', label: '备注', minWidth: 280 },
      ],
      tableData: []
    }
  },
  created () {
    this.$api.contract.getListClientsForElectricOperationsCompany(0, null, null).then((res) => {
      if (res.success) {
        this.allCompany = res.data
      }
    })
    this.$api.contract.getListElectricOperationsContractForServiceProvider(
      0,
      [],
      null,
      null,
      -1
    ).then((res) => {
      if (res.success) {
        this.contactList = res.data
      }
    })
    this.handleQuery()
  },
  methods: {
    handleQuery () {
      this.$api.contract.getContractProjectByContractId({
        ...this.filters
      }).then((res) => {
        if (res.success) {
          this.tableData = res.data
        }
      })
    },
    handleAdd () {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(null)
      })
    },
    handleEdit (params) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(params.row)
      })
    },
    handleProjectConfig (params) {
      console.log(params)
      this.projectConfigVisible = true
      this.$nextTick(() => {
        this.$refs.projectConfig.init(params.row)
      })
    },
    handleClientContactInfo (params) {
      this.clientContactInfoVisible = true
      this.$nextTick(() => {
        this.$refs.clientContactInfo.init(params.row)
      })
    },
    handleDelete (params) {
      const id = [params.row.projectId]
      this.$confirm('确认要删除吗？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.$api.contract.deleteContractProjects(id).then(res => {
          if (res.success) {
            this.$message.success("删除成功")
            this.handleQuery()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  text-align: left;
  color: #333;
}
</style>
